import(/* webpackMode: "eager" */ "/app/app/(main)/privacypolicy/page.js");
